import mock from '@/fake-db/mock.js'

const data = {
  projects: [
    {
      'id': 268,
      'project_name': 'Sophie living',
      'project_slug': 'sophie-living',
      'project_logo': require('@/assets/images/projects/sophie_living_logo.png'),
      'project_visualisation': require('@/assets/images/projects/sophie_living_visualisation.png'),
      'project_cover_img': require('@/assets/images/projects/sophie_living_cover_img.jpg'),
      'email': 'support@sophieiving.com',
      'role': 'admin',
      'status': 'active',
      'is_verified': false,
      'property_type': 'office',
      'units_qty': 154,
      'gross_area': 8.080,
      'sales_price_range': [10, 50],
      'company': 'WinDon Technologies Pvt Ltd',
      'mobile': '+65958951757',
      'website': 'https://rowboat.com/insititious/Angelo',
      'languages_known': ['English', 'German'],
      'contact_options': ['email', 'message'],
      'location': {
        'add_line_1': 'Kohlmarkt 8-10, 1.OG',
        'add_line_2': '',
        'post_code': 'A-1010',
        'city': 'Vienna',
        'country': 'Austria'
      },
      'social_links': {
        'facebook': 'https://www.facebook.com/sophie-living',
        'instagram': 'https://www.instagram.com/sophie-living/'
      },
      'post_info': {
        'created': {
          'date': 'Mon Dec 10 2018 07:46:00 GMT+0000 (GMT)',
          'author': {
            'user_id': 123,
            'user_name': 'Alona Lanela',
            'user_avatar': require('@/assets/images/portrait/small/avatar-s-1.jpg')
          },
        },
        'modified': {
        }

      }

    },
    {
      'id': 269,
      'project_name': 'Micro53',
      'project_slug': 'micro53-abnahme',
      'project_logo': '@/assets/images/projects/micro53_abnahme_logo.png',
      'project_visualisation': '@/assets/images/projects/micro53_abnahme_visualisation.png',
      'project_cover_img': '@/assets/images/projects/micro53_abnahme_cover_img.jpg',
      'email': 'support@micro53.com',
      'role': 'admin',
      'status': 'inactive',
      'is_verified': true,
      'property_type': 'condominium',
      'units_qty': 2,
      'gross_area': 600,
      'sales_price_range': '2000-6000',
      'company': 'Reitenberger',
      'mobile': '+65958951757',
      'website': 'https://reitenberger.de',
      'languages_known': ['English', 'Arabic'],
      'contact_options': ['email', 'message'],
      'location': {
        'add_line_1': 'Kohlmarkt 8-10, 1.OG',
        'add_line_2': '',
        'post_code': 'A-1010',
        'city': 'Vienna',
        'country': 'Austria'
      },
      'social_links': {
        'facebook': 'https://www.facebook.com/sophie-living',
        'instagram': 'https://www.instagram.com/sophie-living/'
      },
      'post_info': {
        'created': {
          'date': 'Mon Dec 10 2018 07:46:00 GMT+0000 (GMT)',
          'author': {
            'user_id': 123,
            'user_name': 'Alona Lanela',
            'user_avatar': require('@/assets/images/portrait/small/avatar-s-1.jpg')
          },
        },
        'modified': {
        }

      }

    },

  ]
}


mock.onGet('/api/project-management/projects').reply(() => {
  return [200, JSON.parse(JSON.stringify(data.projects)).reverse()]
})

// GET: Fetch Single Project Details
mock.onGet(/\/api\/project-management\/projects\/\d+/).reply((request) => {

  const projectId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const project = data.projects.find((project) => project.id == projectId)

  return project ? [200, JSON.parse(JSON.stringify(project))] : [404]
})

// // POST : Add new Item
// mock.onPost("/api/data-list/products/").reply((request) => {

//   // Get event from post data
//   let item = JSON.parse(request.data).item

//   const length = data.products.length
//   let lastIndex = 0
//   if(length){
//     lastIndex = data.products[length - 1].id
//   }
//   item.id = lastIndex + 1

//   data.products.push(item)

//   return [201, {id: item.id}]
// })

// // Update Product
// mock.onPost(/\/api\/data-list\/products\/\d+/).reply((request) => {

//   const itemId = request.url.substring(request.url.lastIndexOf("/")+1)

//   let item = data.products.find((item) => item.id == itemId)
//   Object.assign(item, JSON.parse(request.data).item)

//   return [200, item]
// })

// // DELETE: Remove Item
mock.onDelete(/\/api\/project-management\/projects\/\d+/).reply((request) => {

  const projectId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const itemIndex = data.projects.findIndex((p) => p.id == projectId)
  data.projects.splice(itemIndex, 1)
  return [200]
})
